import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function AzureIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon viewBox="0 0 54 50" fill="none" {...props}>
      <g clipPath={`url(#azure-a-${id})`}>
        <path
          d="M18.002-.003h15.98L17.394 48.294a2.542 2.542 0 0 1-2.415 1.703H2.543C1.14 49.997 0 48.877 0 47.498c0-.272.046-.542.134-.8L15.588 1.7a2.547 2.547 0 0 1 2.414-1.703Z"
          fill={`url(#azure-b-${id})`}
        />
        <path
          d="M41.222 32.392H15.883c-.648 0-1.172.515-1.172 1.152 0 .32.134.626.374.844l16.282 14.934a2.58 2.58 0 0 0 1.747.676h14.348l-6.236-17.606h-.004Z"
          fill="#0078D4"
        />
        <path
          d="M18-.003a2.521 2.521 0 0 0-2.418 1.735L.152 46.657c-.473 1.297.212 2.728 1.534 3.193.277.097.57.147.866.147h12.755a2.717 2.717 0 0 0 2.094-1.748l3.076-8.91 10.99 10.073c.462.374 1.039.58 1.637.588h14.295l-6.27-17.606-18.277.005L34.038-.003H18.001Z"
          fill={`url(#azure-c-${id})`}
        />
        <path
          d="M38.413 1.698A2.545 2.545 0 0 0 36-.002H18.193a2.54 2.54 0 0 1 2.41 1.7l15.456 45c.45 1.308-.266 2.725-1.597 3.168a2.613 2.613 0 0 1-.813.131h17.808c1.405 0 2.543-1.12 2.543-2.501 0-.272-.046-.542-.134-.799L38.413 1.698Z"
          fill={`url(#azure-d-${id})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`azure-b-${id}`}
          x1="23.827"
          y1="3.703"
          x2="7.744"
          y2="52.048"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B" />
          <stop offset="1" stopColor="#0669BC" />
        </linearGradient>
        <linearGradient
          id={`azure-c-${id}`}
          x1="29.009"
          y1="26.153"
          x2="25.185"
          y2="27.468"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity=".3" />
          <stop offset=".07" stopOpacity=".2" />
          <stop offset=".32" stopOpacity=".1" />
          <stop offset=".62" stopOpacity=".05" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`azure-d-${id}`}
          x1="27.019"
          y1="2.254"
          x2="44.684"
          y2="50.146"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4" />
          <stop offset="1" stopColor="#2892DF" />
        </linearGradient>
        <clipPath id={`azure-a-${id}`}>
          <path fill="white" d="M0 0h54v50H0z" />
        </clipPath>
      </defs>
    </Icon>
  );
}
